import React from "react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/common";
import { useSEO } from "@/lib/useSEO";
import { CONTACT } from "@/config/site";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-bold text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
  </div>
);

export default function Terms() {
  useSEO({ title: "Terms & Conditions | Atmasamman Group", description: "The terms that apply to your use of the Atmasamman Group website.", path: "/terms" });
  return (
    <Layout>
      <PageHero eyebrow="Legal" title="Terms & Conditions" subtitle="Please read these terms carefully before using the Atmasamman Group website." />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Section title="Use of This Website">
            <p>This website provides information about Atmasamman Group and its organizations. By using the site, you agree to use it for lawful purposes and in a manner that does not infringe the rights of others.</p>
          </Section>
          <Section title="Information Accuracy">
            <p>We aim to keep information accurate and up to date. However, content may be updated or changed without notice, and we do not warrant that all information is complete or error-free.</p>
          </Section>
          <Section title="External Links">
            <p>Our website links to the independent websites of ATS, ASAI and AIMT. We are not responsible for the content, policies or practices of these external sites.</p>
          </Section>
          <Section title="Enquiries">
            <p>Submitting an enquiry does not create any contractual obligation. It simply allows our team to contact you regarding your request.</p>
          </Section>
          <Section title="Intellectual Property">
            <p>The Atmasamman Group name, logos and content are the property of their respective owners and may not be used without permission.</p>
          </Section>
          <Section title="Contact Us">
            <p>Questions about these terms can be sent to <a href={`mailto:${CONTACT.primaryEmail}`} className="font-medium text-orange-600 hover:underline">{CONTACT.primaryEmail}</a>.</p>
          </Section>
        </div>
      </section>
    </Layout>
  );
}
